import React from "react";
import Select from "react-select";
import { IoEnterOutline } from "react-icons/io5";
import { IoExitOutline } from "react-icons/io5";
import { TbTransferIn } from "react-icons/tb";
import { Tooltip } from "react-tooltip";
import { primaryColor, stylesofStype } from "../../utils/comman/Common";
import WalletDateFilter from "../../utils/comman/statusDateFilter";
const FilterSection = ({
  applyStatus,
  statusOption,
  changeHandler,
  selectedStatus,
  filterupdatedOn,
  setFilterupdatedOn,
  fromDateHandler,
  formDate,
  toDateHandler,
  toDate,
  checkDisable,
  resetApply,
  dropdownOpen,
  handleOpenShowAmount,
  showTotalWalletBalance,
  isDropdownOpen,
  toggleDropdown,
}) => {
  const payInType = "payin";
  const payoutType = "payout";

  return (
    <>
      <Tooltip id="merchant-tooltip" effect="solid" />
      <div className="col-12 col-md-6 float-right dropdown fltr">
        <button
          type="button"
          title="Filter"
          className="filter dropdown-toggle"
          id="fillist"
          data-bs-boundary="viewport"
          onClick={toggleDropdown}
          aria-expanded={isDropdownOpen}
        >
          Filter
        </button>
        <div
          className={`dropdown-menu dropdown-menu-right ${
            isDropdownOpen ? "show" : ""
          }`}
          id="filterbox"
          aria-labelledby="fillist"
        >
          <form onSubmit={applyStatus}>
            {/* <div className="col-12 col-md-12 mb-2 border-bottom">
              <div className="form-floating">
                <div className="formselect mb-2">
                  <label>Selected Status</label>
                  <Select
                    className="basic-multi-select"
                    styles={stylesofStype}
                    closeMenuOnSelect={false}
                    components={{
                      IndicatorsContainer: () => null,
                      IndicatorSeparator: () => null,
                    }}
                    isMulti
                    options={statusOption}
                    onChange={changeHandler}
                    value={selectedStatus}
                    placeholder=" select multiple option"
                  />
                </div>
              </div>
            </div> */}
            {/* <div
              style={{ borderBottom: "1px solid #dee2e6" }}
              className="filters"
            >
              <label htmlFor="filterupdatedOn">Updated On</label>
              <div className="form-check form-switch">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="filterupdatedOn"
                  value={filterupdatedOn}
                  onChange={(e) => setFilterupdatedOn(e.target.checked)}
                />
              </div>
            </div> */}
            <div className="filters">
              <label htmlFor="select-state">From Date:</label>
              <input type="date" onChange={fromDateHandler} value={formDate} />
            </div>
            <div className="filters">
              <label htmlFor="select-state">To Date:</label>
              <input
                min={formDate}
                type="date"
                onChange={toDateHandler}
                value={toDate}
              />
            </div>
            <div className="fbtn">
              <button className="btn" type="submit" id="btnapply">
                Export file
              </button>
              {/* <button
                className="btn"
                type="reset"
                id="btnclear"
                // onClick={resetApply}
              >
                Clear
              </button> */}
            </div>
          </form>
        </div>
        <span>
          {" "}
          <IoEnterOutline
            data-tooltip-id="merchant-tooltip"
            data-tooltip-content={`Payin balance`}
            size={20}
            style={{ color: primaryColor }}
          />
          ₹ {showTotalWalletBalance(payInType)}
        </span>{" "}
        <button
          className="btn"
          type="submit"
          id="btnapply"
          style={{ backgroundColor: primaryColor }}
          // disabled={checkDisable()}
          disabled
        >
          <TbTransferIn
            data-tooltip-id="merchant-tooltip"
            data-tooltip-content={`Click to transfer balance from payin to payout`}
            style={{ color: "#fff" }}
            onClick={() => handleOpenShowAmount()}
            size={25}
          />{" "}
        </button>{" "}
        <br />
        <span>
          {" "}
          <IoExitOutline
            size={20}
            data-tooltip-id="merchant-tooltip"
            data-tooltip-content={`Payout balance`}
            style={{ color: primaryColor, marginTop: "5px" }}
          />
          ₹ {showTotalWalletBalance(payoutType)}
        </span>
      </div>
    </>
  );
};

export default FilterSection;
